<template>
    <div class="radio-box" :class="{'larger': is_larger}" :is_larger="is_larger" :list="list">
        <div class="btn" v-for="(item, index) in list" :key="index" :class="{'choosed': value == item.value}">
            <button @click="choose(item)">{{item.name}}</button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'base-radio',
    props: {
        val: {
            require: true,
            default: -1,
        },
        list: {
            type: Array,
            require: true,
        },
        is_larger: {
            require: false,
            default: false,
        },
    },
    data() {
        return {
            value: '',
        }
    },
    created() {
        this.value = this.val
    },
    methods: {
        choose(item) {
            this.value = item.value
            this.$emit('choose', this.value)
        },
    },
}
</script>
<style lang="scss" scoped>
.radio-box {
    width: 100%;
    height: 0.64rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .btn {
        width: 2rem;
        height: 0.64rem;
        background: transparent;
        border: 0.02rem solid #c39b5e;
        border-radius: 0.32rem;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0.05rem;
        button {
            width: calc(100% - 0.06rem);
            color: #c39b5e;
            font-size: 0.26rem;
            text-align: center;
            height: calc(100% - 0.06rem);
            line-height: calc(100% - 0.06rem);
            background: transparent;
            border-radius: 0.5rem;
            cursor: pointer;
            transition: opacity 0.2s;
            outline: none;
            position: relative;
            &::before {
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100%;
                height: 100%;
                background: linear-gradient(0deg, #624a23, #271d09);
                border: inherit;
                border-color: linear-gradient(0deg, #4b3719, #94763e);
                border-radius: inherit;
                transform: translate(-50%, -50%);
                opacity: 0;
                content: ' ';
            }
            &:active::before {
                opacity: 0.1;
            }
        }

        &.choosed {
            background: linear-gradient(0deg, #c4a160, #6f542b);

            button {
                color: #ffebc6;
                font-size: 0.26rem;
                text-align: center;
                background: linear-gradient(0deg, #836638, #4f4023);
            }
        }
    }

    &.larger {
        width: 100%;
        height: 0.78rem;
        .btn {
            width: 2.46rem;
            height: 0.78rem;
            margin: 0 0.15rem;
            border-radius: 0.39rem;
            button {
                font-size: 0.3rem;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/BaseRadio.vue